export default __webpack_public_path__ + "static/media/long-pellets-icon.ce965e1b.svg";